export default "__VITE_ASSET__Dweojxpx__"